import {
  type ApplicationContractResponse,
  type ApplicationResponse,
} from '@acme/api';
import { CopyableText, renderFieldIfText } from '@acme/foundation';

export const ApplicationMainInfo = ({
  application,
  contract,
}: {
  application: ApplicationResponse;
  contract: ApplicationContractResponse | null;
}) => {
  return (
    <div className="flex flex-col gap-6">
      {contract?.isCryptoPayment ? (
        <div className="flex flex-col gap-1 flex-1 min-w-0">
          <p className="text-sm text-gray-500">Адрес криптокошелька</p>
          <CopyableText
            value={contract?.counterpartyAddress}
            className="items-center text-gray-900 text-base font-medium"
          />
        </div>
      ) : (
        <div className="grid grid-cols-3 gap-6">
          {renderFieldIfText('Страна назначения', contract?.country?.name)}
          {renderFieldIfText('Название банка', contract?.bankName)}
          {renderFieldIfText('Адрес банка', contract?.bankAddress)}
          {renderFieldIfText('IBAN', contract?.iban)}
          {renderFieldIfText('SWIFT/BIC', contract?.swifT_BIC)}
        </div>
      )}
      <div className="grid grid-cols-3 gap-6">
        {renderFieldIfText(
          'Сумма криптовалюты',
          contract?.cryptoAmount?.toString()
        )}
        {renderFieldIfText('Криптовалюта', contract?.cryptocurrency?.name)}
      </div>
    </div>
  );
};
